import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { addUser, updateUserInfo } from '@/api/user';
import { ElMessage } from 'element-plus';
import { formRule, updateFormRule } from '../config';
export default {
  __name: 'add',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'getData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const dialogVisible = useVModel(props);
    const formRef = ref(null);
    const form = ref({
      username: '',
      password: '',
      name: '',
      mobile: ''
    });
    const resetForm = () => {
      formRef.value.resetFields();
      form.value = {
        username: '',
        password: '',
        name: '',
        mobile: ''
      };
    };
    watch(() => props.model, val => {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.resetFields();
      if (val) {
        form.value = {
          ...val
        };
      }
    }, {
      deep: true,
      immediate: true
    });
    const submitForm = async () => {
      try {
        await formRef.value.validate();
        if (!props.model) {
          await addUser(form.value);
        } else {
          if (!form.value.password) {
            form.value.password = null;
          }
          await updateUserInfo({
            ...form.value
          });
        }
        emits('getData');
        ElMessage({
          type: 'success',
          message: '添加成功'
        });
        resetForm();
        dialogVisible.value = false;
      } catch (error) {
        ElMessage.warning('校验失败');
      } finally {}
    };
    const handleClose = () => {
      emits('clearModel');
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "添加平台账号",
        class: "dialog-class",
        onClosed: handleClose,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          "label-width": "150px",
          rules: __props.model ? _unref(updateFormRule) : _unref(formRule),
          "status-icon": "",
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "username",
            label: "账号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.username = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "password",
            label: "密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.password = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "name",
            label: "姓名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "mobile",
            label: "手机号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.mobile,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.mobile = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};